"use strict";
/*
 * Created on 3. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");
/**
 * Specification of sellout release item. Used for bulk update operations, but it is not limited for this usage only.
 * @author Radek Beran
 */


var SelloutReleaseItemKey =
/*#__PURE__*/
function () {
  /**
   * @param releaseId release id
   * @param productId product id
   * @param siteId site id; or null if products on all their sites should be used
   */
  function SelloutReleaseItemKey(releaseId, productId, siteId) {
    _classCallCheck(this, SelloutReleaseItemKey);

    this.releaseId = releaseId;
    this.productId = productId;
    this.siteId = siteId;
  }

  _createClass(SelloutReleaseItemKey, [{
    key: "equals",
    value: function equals(other) {
      return this.releaseId === other.releaseId && this.productId === other.productId && this.siteId === other.siteId;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.releaseId, "_").concat(this.productId, "_").concat(this.siteId));
    }
  }]);

  return SelloutReleaseItemKey;
}();

exports.SelloutReleaseItemKey = SelloutReleaseItemKey;

SelloutReleaseItemKey.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItemKey.name);
  return {
    releaseId: builder.str('releaseId'),
    productId: builder.str('productId'),
    siteId: builder.opt(builder.str('siteId'))
  };
}();